import {ReactNode, createContext} from 'react';

export type NotificationModalState = {
    isVisible: boolean;
    message?: string;
    description?: string;
    buttonText?: string;
    icon?: ReactNode;
    onConfirm?: () => void;
    type: 'success' | 'error';
};

type NotificationModalContextParams = {
    state: NotificationModalState;
    openNotifyModal: (
        params: Partial<Omit<NotificationModalState, 'isVisible'>>,
    ) => void;
    closeNotifyModal: () => void;
};

export const NotificationModalContext =
    createContext<NotificationModalContextParams>({
        state: {
            isVisible: false,
            message: '',
            type: 'success',
        },
        openNotifyModal: () => null,
        closeNotifyModal: () => null,
    });
